export default {
  state: {
    toolTypeInfoList: [],
    laborTypeInfoList: [],
    toolUnitList: [],
    toolSupplierList: []
  },
  getters: {
    toolTypeInfoList: state => state.toolTypeInfoList,
    laborTypeInfoList: state => state.laborTypeInfoList,
    toolUnitList: state => state.toolUnitList,
    toolSupplierList: state => state.toolSupplierList
  },
  mutations: {
    toolTypeInfoList (state, data) {
      state.toolTypeInfoList = data
    },
    laborTypeInfoList (state, data) {
      state.laborTypeInfoList = data
    },
    toolUnitList (state, data) {
      state.toolUnitList = data
    },
    toolSupplierList (state, data) {
      state.toolSupplierList = data
    }
  },
  actions: {
    handleToolTypeInfoList (toolTypeInfoList, data) {
      toolTypeInfoList.commit('toolTypeInfoList', data)
    },
    handleLaborTypeInfoList (laborTypeInfoList, data) {
      laborTypeInfoList.commit('laborTypeInfoList', data)
    },
    handleToolUnitList (toolUnitList, data) {
      toolUnitList.commit('toolUnitList', data)
    },
    handleToolSupplierList (toolSupplierList, data) {
      toolSupplierList.commit('toolSupplierList', data)
    }
  }
}
